<template>
	<view style="width: 100%;height: 100%;overflow: hidden;position: absolute;top: 0;left: 0;background-color: #fff;">
		<view style="display: block;width: 100%;height: 60rpx;padding-top: 86rpx;text-align: center;background-color: #fff;box-shadow: 0 1px 6px #ccc;">
			<view style="position: absolute;left: 20rpx;top: 50rpx;z-index: 999;" @tap="back">
				<uni-icons type="back" size="60r" color="#000"></uni-icons>
			</view>
			<text style="font-size: 32rpx;position: relative;top: -12rpx;">跑街令车架号查询</text>
		</view>
		<view style="position: relative;border-bottom: 1px solid #e6e6e6;">
			<input class="inp-search" type="text" name="vin" :value="vin" @input="setVin">
			<view style="position: absolute;top: 14rpx;left: 30rpx;">
				<uni-icons type="search" size="35r" color="#aaa"></uni-icons>
			</view>
			<text class="btn-search" @tap="fetchData">搜索</text>
		</view>
		<view class="content">
			<view class="item" v-for="(item,index) in data" :key="index">
				<view @tap="toNextPage(item)">
					<text class="title">{{item.make_name}} {{item.mod2_name}} {{item.mod3_name}} {{item.vin_year}}</text>
					<text class="desc">{{item.mod3_engine}} {{item.mod3_kw}}kw {{item.mod3_cc}}cc {{item.mod3_transmission}} {{item.mod3_drive}} {{item.mod3_fuel}}</text>
					<view class="icon">
						<uni-icons type="forward" size="35r" color="#df0707"></uni-icons>
					</view>					
				</view>
			</view>
		</view>
	</view>
</template>

<script>
	const app = getApp();
	export default {
		onLoad(option) {
			this.vin = option.vin
			this.fetchData()
		},
		data() {
			return {
				vin: '',
				data: [],
			}
		},
		methods: {
			back() {
				uni.switchTab({url:'/pages/index/index'})
			},
			fetchData() {
				let that = this
				app.getApi('GET', 'data/decodeVin', {vin:this.vin}, 1, function (data) {
					that.data = data
				});
			},
			setVin(e) {
				this.vin = e.detail.value
			},
			toNextPage(item) {
				uni.redirectTo({url:'/pages/item/search?type=model&mod3_id='+item.mod3_id})
			}
		}
	}
</script>

<style>
	.btn-search{background-color: #df0707;color: #fff;padding: 2rpx 22rpx;border-radius: 30rpx;font-size: 23rpx;position: absolute;top: 20rpx;right: 26rpx;}
	.inp-search{font-size: 28rpx;padding-left: 50rpx;display: inline-block;width: 72%;background-color: #ddd;border-radius: 20rpx;margin: 20rpx;height: 46rpx;margin-bottom: 4rpx;}
	.item{padding: 22rpx 30rpx;border-bottom: 1px solid #e6e6e6;position: relative;}
	.title{font-size: 30rpx;color: #212832;display: block;width: 85%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;vertical-align: bottom;}
	.desc{display: block;width: 85%;color: #999;font-size: 26rpx;}
	.icon{position: absolute;right: 40rpx;top: 50%;width: 20px;height: 20px;line-height: 20px;text-align: center;background-color: #feece8;border-radius: 20px;margin-top: -10px;}
</style>
